import React from 'react';
import ReactDOM from 'react-dom';
import './styles/external/bootstrap4-daydream.min.css';
import './styles/scss/index.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('app-root'));
registerServiceWorker();
